module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered is-centered"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login_to_your_account').tUpper())
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateCaptcha()
      }
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('email').tTitle()) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.email),
      expression: "data.body.email"
    }],
    staticClass: "ete-input input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.data.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('password').tTitle()) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "ete-input input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "chk-rem-me",
      "name": "chk-rem-me"
    }
  }), _vm._v("  \n            "), _c('label', {
    staticClass: "label",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "for": "chk-rem-me",
      "id": "lbl-rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('remember_me')))]), _vm._v(" "), _c('router-link', {
    staticClass: "forgotPassword",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "lnk-forgot-pass",
      "to": '/' + (_vm.Language || 'en') + '/forgot-password'
    }
  }, [_vm._v(_vm._s(_vm.$t('forgot_password_q').tTitle()))])], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-primary login",
    attrs: {
      "type": "submit",
      "id": "btn-ete-submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('login').tUpper()))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "is-title is-bold",
    staticStyle: {
      "font": "normal normal 900 23px/20px Roboto"
    }
  }, [_vm._v(_vm._s(_vm.$t('not_registered_with_question').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "columns regButtons"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('router-link', {
    staticClass: "button is-primary reg",
    attrs: {
      "id": "btn-ete-open-live",
      "to": '/' + (_vm.Language || 'en') + '/register/live'
    }
  }, [_vm._v(_vm._s(_vm.$t('open_live_account').tUpper()))])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('router-link', {
    staticClass: "button is-secondary-outline reg",
    attrs: {
      "id": "btn-ete-open-demo",
      "to": '/' + (_vm.Language || 'en') + '/register/demo'
    }
  }, [_vm._v(_vm._s(_vm.$t('open_demo_account').tUpper()))])], 1)]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "vertical-space"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "is-center"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', {
    attrs: {
      "id": "spn-your-data"
    }
  }, [_vm._v(_vm._s(_vm.$t('risk_sentence')))]), _vm._v(" "), _c('a', {
    staticClass: "is-small",
    staticStyle: {
      "color": "white",
      "font": "normal normal 550 12px/14px Roboto"
    },
    attrs: {
      "href": "https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Privacy%20Policy.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_policy').tTitle()))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "select is-small lang"
  }, [_c('language')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eurotrader_logo_rgb_purple.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39806b87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Login.vue
// module id = 749
// module chunks = 0